import './go-top/go-top'
import imageLazy from './image-lazy/image-lazy'
/*import './bootstrap/bootstrap'*/

imageLazy.init()
